import { ReceivedShareGoalInvitesQuery, ReceivedShareGoalInvitesQueryVariables } from "@ctypes";
import { RECEIVED_SHARE_GOAL_INVITES } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useReceivedSharedGoalInvites = () => {
  const { data: queryData, ...rest } = useQuery<
    ReceivedShareGoalInvitesQuery,
    ReceivedShareGoalInvitesQueryVariables
  >(RECEIVED_SHARE_GOAL_INVITES);

  const data = queryData?.receivedShareGoalInvites;

  return { data, ...rest };
};
